import React, { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Divider,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Typography,
  Dialog,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { useAuth } from "../../context/API_Client";
import CustomButton from "../../reusableComponents/CustomButton";
import { customToast } from "../../reusableComponents/customToaster/customToast";

function ChangePassword({ openCP, onCloseCP, responseData, setPassword }) {
  const { changePassword } = useAuth();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [responseErr, setResponseErr] = useState("");
  const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  const schema = yup.object().shape({
    oldPassword: yup.string().required("Required"),
    password: yup
      .string()
      .matches(passwordRules, { message: "Please create a stronger password" })
      .required("Required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Required"),
  });

  const { handleSubmit, control, formState, setValue, reset } = useForm({
    resolver: yupResolver(schema),
  });

  const handleClickShowPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleMouseDownPassword = (event) => {
    if (event) {
      event.preventDefault()
    }
  };

  const updatePassword = (formData) => {
    changePassword(
      null,
      {
        oldPassword: formData.oldPassword,
        newPassword: formData.confirmPassword,
      },
      function (data) {
        onCloseCP();
      },
      function (errMsg) {
        setResponseErr(errMsg);
        customToast("error", "high", errMsg);
      }
    );
  };
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      onCloseCP();
      reset();
    }
  };
  return (
    <div>
      <Dialog
        className="changePassowordModal"
        open={openCP}
        onKeyDown={handleKeyDown}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "6px",
            padding: "24px 24px 0px 24px",
          }}
        >
          <Typography className="SemiboldTwenty font-black-highest">
            Change Password
          </Typography>
          <img
            src="/assets/ic_twotone-close.svg"
            alt="cross"
            onClick={() => {
              onCloseCP();
              reset();
            }}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Typography
          className="labelRegular font-black-high"
          style={{ padding: "0px 24px" }}
        >
          Your password must be at least 8 characters long and include a number,
          an uppercase letter and a lowercase letter
        </Typography>
        <Divider
          style={{
            margin: "16px 24px",
          }}
        />
        <form onSubmit={handleSubmit(updatePassword)}>
          <div
            style={{
              height: "190px",
              overflowY: "scroll",
              padding: "0px 24px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                className="bodyB2RegularText font-black-highest"
                style={{ marginTop: "12px" }}
              >
                Old Password
              </Typography>
              <div>
                <Controller
                  name="oldPassword"
                  control={control}
                  render={({ field }) => (
                    <OutlinedInput
                      {...field}
                      id="oldPassword"
                      name="oldPassword"
                      style={{ width: "405px" }}
                      aria-describedby="outlined-title-helper-text"
                      placeholder="Enter Old Password"
                      type={showNewPassword ? "" : "password"}
                    />
                  )}
                />
                {formState.errors.oldPassword && (
                  <span
                    className="error"
                    style={{
                      color: "var(--comms-negative, #B9232F)",
                      fontSize: "10px",
                      marginTop: "2px",
                    }}
                  >
                    <img
                      src="/assets/errorOutline.svg"
                      style={{
                        height: "12px",
                        width: "12px",
                        paddingBottom: "1px",
                      }}
                    />{" "}
                    {formState.errors.oldPassword.message}
                  </span>
                )}
              </div>
            </div>
            <div style={{ marginTop: "24px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  className="bodyB2RegularText font-black-highest"
                  style={{ marginTop: "12px" }}
                >
                  New Password
                </Typography>
                <div style={{}}>
                  <Controller
                    name="password"
                    control={control}
                    render={({ field }) => (
                      <OutlinedInput
                        {...field}
                        style={{ width: "405px" }}
                        id="password"
                        name="password"
                        aria-describedby="outlined-title-helper-text"
                        placeholder="Enter New Password"
                        type={showNewPassword ? "" : "password"}
                      />
                    )}
                  />
                  {formState.errors.password && (
                    <span
                      className="error"
                      style={{
                        color: "var(--comms-negative, #B9232F)",
                        fontSize: "10px",
                        marginTop: "2px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src="/assets/errorOutline.svg"
                        style={{
                          height: "12px",
                          width: "12px",
                          paddingBottom: "1px",
                        }}
                      />{" "}
                      {formState.errors.password.message}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div style={{ margin: "24px 0px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  className="bodyB2RegularText font-black-highest"
                  style={{ marginTop: "12px" }}
                >
                  Confirm
                </Typography>
                <div>
                  <Controller
                    name="confirmPassword"
                    control={control}
                    render={({ field }) => (
                      <OutlinedInput
                        {...field}
                        style={{ width: "405px" }}
                        id="confirmPassword"
                        name="confirmPassword"
                        aria-describedby="outlined-title-helper-text"
                        placeholder="Confirm Password"
                        type={showConfirmPassword ? "" : "password"}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showConfirmPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    )}
                  />
                  {formState.errors.confirmPassword && (
                    <span
                      className="error"
                      style={{
                        color: "var(--comms-negative, #B9232F)",
                        fontSize: "10px",
                        marginTop: "2px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src="/assets/errorOutline.svg"
                        style={{
                          height: "12px",
                          width: "12px",
                          paddingBottom: "1px",
                        }}
                      />{" "}
                      {formState.errors.confirmPassword.message}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              paddingBottom: "24px",
              paddingTop: "24px",
              paddingRight: "24px",
              boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
            }}
          >
            <div style={{ paddingRight: "20px" }}>
              <CustomButton
                text={"Cancel"}
                type={"secondary"}
                size={"sm"}
                onClick={() => {
                  onCloseCP();
                  reset();
                }}
              />
            </div>
            <CustomButton
              text={formState.isSubmitting ? "Changing..." : "Change"}
              type={"secondary"}
              size={"sm"}
              variant={"contained"}
              onClick={handleSubmit(updatePassword)}
              disabled={formState.isSubmitting}
            />
          </div>
        </form>
      </Dialog>
    </div>
  );
}

export default ChangePassword;
